import type { ComponentPropsWithoutRef, FC } from 'react';
import { classes } from 'typestyle';

interface SidebarButtonProps extends ComponentPropsWithoutRef<'button'> {
  className?: string;
  icon?: string;
  label?: string;
  visible?: boolean;
  padBottom?: boolean;
}

export const SidebarButton: FC<SidebarButtonProps> = ({
  className = 'btn btn-sidebar',
  children,
  icon,
  label,
  visible = true,
  padBottom = true,
  ...buttonProps
}) => {
  if (!visible) return null;
  return (
    <button className={classes(padBottom && 'pod-menu-item', className)} type="button" {...buttonProps}>
      {icon && <i className={classes('fa', icon, 'pr-2')} />}
      {label}
      {children}
    </button>
  );
};
